import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useFetch, useApiClient, useFetchImmutable } from '@marageti/z4-lib';
import { TripMatch, SalesRecording } from '@marageti/z4-sdk/lib/travel';
import { CountryCodeMap } from '@marageti/z4-sdk/lib/standards';
import SalesRecordingView from './sales-recording-view';
import useDocumentDownload from '../../../hooks/use-document-download';

const SalesRecordingContainer = () => {
  const apiClient = useApiClient();
  const { tripMatchId, salesRecordingId } = useParams();

  const { data: countryCodes, isLoading: isLoadingCC } = useFetchImmutable<CountryCodeMap>(apiClient.standardsClient.getCountryCodes, [], true);
  const { data: tripMatch, isLoading: isLoadingTM } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], true);
  const {
    data: salesRecording, isLoading: isLoadingSR, error,
  } = useFetch<SalesRecording>(apiClient.salesRecordingsClient.getSalesRecording, [salesRecordingId, { params: { trip_match: tripMatchId } }], true);

  const [onClickDocument, docError] = useDocumentDownload();

  const onClickDownload = () => {
    if (salesRecording?.document) {
      onClickDocument(salesRecording.document);
    }
  };

  if (error?.code === 404) {
    return <Navigate to={`/trip-matches/${tripMatchId}/sales`} replace />;
  }

  return (
    <SalesRecordingView
      countryCodes={countryCodes}
      docError={docError}
      isLoading={isLoadingCC || isLoadingTM || isLoadingSR}
      onClickDownload={onClickDownload}
      salesRecording={salesRecording}
      tripMatch={tripMatch}
    />
  );
};

export default SalesRecordingContainer;
